// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__16RFH","title":"Info_title__1YotI","selects":"Info_selects__3F0EQ","requiredAsterisk":"Info_requiredAsterisk__--nzR"};